import Swiper, { Navigation, Pagination } from 'swiper';
import { windowatch } from '../../../scripts/lib/windowatch';

// TODO Optimization: Run loop animations only when slider is inside viewport
export default class Slider {

  constructor ($el) {

    this.$el = $el;
    this.swiper = null;
    this.index = 0;

    this.isTeaserboxSliderVariant = false;
    this.isFactsTickerVariant = false;

    this.hasPagination = false;

    this.mobileTeaserboxLayout = false;
    this.dragLeftDisabled = false;
    this.dragRightDisabled = true;

    // Bind swiper elements
    this.$container = $el.querySelector('.slider__container');
    this.$drag = $el.querySelector('.slider__drag');
    this.$dragIcon = $el.querySelector('.slider__drag-icon');
    this.$pagination = $el.querySelector('.slider__pagination');
    this.$mediaWrapper = $el.querySelector('.slider__media');
    this.$prevEl = $el.querySelector('.icon__arrow-left');
    this.$nextEl = $el.querySelector('.icon__arrow-right');

    // These are the default options for every slider on the page
    this.options = {
      // Define base classes
      containerModifierClass: 'slider__container--',
      slideClass: 'slider__item',
      slideActiveClass: 'slider__item--active',
      slideDuplicateActiveClass: 'slider__item--duplicate-active',
      slideVisibleClass: 'slider__item--visible',
      slideDuplicateClass: 'slider__item--duplicate',
      slideNextClass: 'slider__item--next',
      slideDuplicateNextClass: 'slider__item--duplicate-next',
      slidePrevClass: 'slider__item--prev',
      slideDuplicatePrevClass: 'slider__item--duplicate-prev',
      wrapperClass: 'slider__item-wrapper',
      // Define standard options
      direction: 'horizontal',
      speed: 400,
      slidesPerView: 'auto',
      // Activate the navigation arrows
      navigation: {
        prevEl: this.$prevEl,
        nextEl: this.$nextEl
      },
      on: {
        slideChangeTransitionEnd: this.onSwiperIndexChange.bind(this),
        progress:
          this.$dragIcon
            ? this.onSwiperProgress.bind(this)
            : null
      },
      modules: [Navigation, Pagination],
    };

    // Merge swiper options, if any
    if ($el.dataset.options) {
      const options = JSON.parse($el.dataset.options);
      this.options = Object.assign(this.options, options);
    }

    // Initialize swiper instance
    this.swiper = new Swiper(this.$container, this.options);
    this.swiper.update();

    // Initialize teaserbox slider variant
    if (this.$el.classList.contains('slider--teaserbox-slider')) {
      // this.initTeaserboxSliderVariant();
    }

    // Initialize facts ticker variant
    if (this.$el.classList.contains('slider--facts-ticker')) {
      this.initFactsTickerVariant();
    }

    if (this.$pagination !== null) {
      this.initPagination();
    }

    // Add breakpoint listener
    windowatch.addBreakpointListener(this.onBreakpointChange.bind(this));
  }

  onBreakpointChange (breakpoint, spec) {

    if (this.swiper) {
      this.swiper.update();
    }

    if (this.isTeaserboxSliderVariant) {
      this.setMobileTeaserboxLayout(breakpoint === 'xs');
    }

    // Count grid columns to find out if slider is scrollable
    let columns = 0;
    if (this.options.itemGridColumns) {
      let itemColumns = this.options.itemGridColumns[breakpoint];
      columns = itemColumns * this.swiper.slides.length;
    }

    // Disable the drag icon if all slides are visible
    if (this.$dragIcon && columns <= 12 && !this.$el.classList.contains('slider--force-drag')) {
      this.$drag.classList.add('slider__drag--hidden');
    } else if (this.$dragIcon) {
      this.$drag.classList.remove('slider__drag--hidden');
    }
  }

  initTeaserboxSliderVariant () {

    this.isTeaserboxSliderVariant = true;
    this.$mediaSlides = [];

    // In a teaserbox slider every item is considered to contain a teaser-box.
    // Bind the media wrapper and the media item for each of them.
    const $items = [...this.$el.querySelectorAll('.slider__item')];

    this.$teaserMediaWrappers = $items.map($item =>
      $item.querySelector('.slider__media-container'));

    this.$teaserMediaItems = this.$teaserMediaWrappers.map($wrapper =>
      $wrapper.querySelector('.image, .video'));
  }

  initFactsTickerVariant () {

    this.isFactsTickerVariant = true;

    // resume autoplay when the pointer leaves the slider
    this.$el.addEventListener('mouseleave', () => {
      if (this.swiper) {
        this.swiper.autoplay.start();
      }
    });
  }

  initPagination () {
    this.hasPagination = true;
    this.$bullets = [...this.$pagination.querySelectorAll('.slider__pagination-bullet')];

    this.$bullets[0].classList.add('slider__pagination-bullet--active');

    this.$bullets.forEach((item, index) => {
      item.addEventListener('click', (event) => {
        this.swiper.slideTo(event.target.getAttribute('data-pagination-index'));
      });
    });
  }

  onSwiperIndexChange () {

    const from = this.index;
    const to = this.swiper ? this.swiper.activeIndex : 0;

    if (this.mobileTeaserboxLayout) {
      this.$mediaSlides[from].classList.add('slider__media-slide--hidden');
      this.$mediaSlides[to].classList.remove('slider__media-slide--hidden');
    }

    if (this.hasPagination) {
      this.$bullets[from].classList.remove('slider__pagination-bullet--active');
      this.$bullets[to].classList.add('slider__pagination-bullet--active');
    }

    this.index = to;
  }

  onSwiperProgress (progress) {

    // const dragLeftDisabled = progress <= 0;
    // const dragRightDisabled = progress > 0.85;

    // if (this.dragLeftDisabled !== dragLeftDisabled) {
    //   this.dragLeftDisabled = dragLeftDisabled;
    //   this.$dragIcon.classList.toggle(
    //     'slider__drag-icon--left-disabled', dragLeftDisabled);
    // }

    // if (this.dragRightDisabled !== dragRightDisabled) {
    //   this.dragRightDisabled = dragRightDisabled;
    //   this.$dragIcon.classList.toggle(
    //     'slider__drag-icon--right-disabled', dragRightDisabled);
    // }
  }

  setMobileTeaserboxLayout (mobileTeaserboxLayout) {

    if (this.mobileTeaserboxLayout !== mobileTeaserboxLayout) {
      this.mobileTeaserboxLayout = mobileTeaserboxLayout;

      if (mobileTeaserboxLayout) {
        // Move teaser media items from the teaser media wrapper
        // to the slider media wrapper
        this.$teaserMediaItems.forEach(($mediaItem, index) => {
          // Create media slide and set hidden state depending on active slide
          const $mediaSlide = document.createElement('div');
          $mediaSlide.classList.add('slider__media-slide');

          if (index !== this.swiper.activeIndex) {
            $mediaSlide.classList.add('slider__media-slide--hidden');
          }

          if ($mediaItem === null) {
            // eslint-disable-next-line no-param-reassign
            $mediaItem = document.createElement('div');
          }

          $mediaSlide.appendChild($mediaItem);
          this.$mediaWrapper.appendChild($mediaSlide);
          this.$mediaSlides.push($mediaSlide);
        });
      } else {
        // Move teaser media items back to their respective media wrappers
        this.$teaserMediaItems.forEach(($mediaItem, index) => {
          const $teaserMediaWrapper = this.$teaserMediaWrappers[index];
          $teaserMediaWrapper.appendChild($mediaItem);
        });
        // Empty slider media wrapper
        this.$mediaWrapper.innerHTML = '';
        this.$mediaSlides = [];
      }
    }
  }
}
